export default __webpack_public_path__ + "media/images/blog/blog-02-770x520-f0d053e645a9e2e8f8593865650163db.jpg";